<template>
    <classical-dashboard-new v-if="isClassical" />
</template>

<script>
export default {
    computed: {
        activeModule() {
            return this.$laravel.active_module
        },
        isClassical(){
            return this.activeModule.module.identifier == 'classical'
        }
    }
}
</script>
